<div class="container">
  <div class="policyheader row">
    <div class="headercontainer col-12 col-md-4">
      <img src="/assets/img/Shield Check.svg" alt="" class="headerimage" />
      <p class="headertext">Privacy Policy</p>
    </div>
    <div class="col-12 col-md-3">
      <strong><p class="policyheadertext">Last modified March, 2024</p></strong>
    </div>
  </div>
  <div>
    <p style="margin-bottom: 14px">
      We at Invitte Technologies Limited (“Invitte”, “we”) respect your privacy
      and are committed to protecting it through our compliance with this
      privacy policy (the “Policy”).
    </p>

    <strong>This policy describes:</strong>
    <br /><br />

    <ol type="i">
      <li>
        The types of information we may collect or that you may provide when you
        download, register with or use the INVITTE[H.E1] application
        downloadable on your mobile device (The “Web App”).
      </li>
      <li style="margin-bottom: 14px">
        Our practices for collecting, using, maintaining, protecting and
        disclosing that information.
      </li>
    </ol>
    <p style="margin-bottom: 14px">
      This Policy applies only to information we collect on the App and in
      email, text and other electronic communications sent through or in
      connection with the App. This policy DOES NOT apply to information that:
    </p>

    <ol type="i">
      <li>
        We collect offline or on any other websites including websites you may
        access through the App,
      </li>
      <li style="margin-bottom: 14px">
        You provide to or is collected by any third party (see Third-Party
        Information Collection).
      </li>
    </ol>

    <p style="margin-bottom: 14px">
      Please read this Policy carefully to understand our policies and practices
      regarding your information and how we will treat it. If you do not agree
      with our policies and practices, do not download, register with or use the
      App. By downloading, registering with or using the App, you agree to this
      Policy. This Policy may change from time to time (see Changes to This
      Policy). Your continued use of the App after we revise this Policy means
      you accept those changes, so please check this Policy periodically for
      updates.
    </p>

    <strong style="margin-bottom: 14px">
      Information We Collect and How We Collect It </strong
    ><br /><br />

    <p style="margin-bottom: 14px">
      We collect information from and about users of the App directly from you
      when you provide information to us and automatically when you use the App.
    </p>
    <strong style="margin-bottom: 14px">Information You Provide to Us</strong
    ><br /><br />
    <p style="margin-bottom: 14px">
      When you download, register with or use the App, we may ask you to provide
      information:
    </p>

    <ol type="i">
      <li>
        By which you may be personally identified, such as your name, address,
        email, telephone number, birth date, financial information or any
        combination of information that could be used to identify you (“personal
        information”).
      </li>
      <li>
        That is about you but individually does not identify you, such as:
        information you provide by filling in forms on the App. This includes
        information provided at the time of registering to use the App. We may
        also ask you for information when you report a problem with the App.
      </li>
      <li>
        Records and copies of your correspondence (including email addresses and
        phone numbers) if you contact us.
      </li>
      <li>
        Your responses to surveys or questions that we might ask you to complete
      </li>
      <li style="margin-bottom: 14px">
        Details of transactions you carry out through the App.
      </li>
    </ol>

    <strong style="margin-bottom: 14px">Automatic Information Collection</strong
    ><br /><br />

    <p style="margin-bottom: 14px">
      When you download, register with or use the App, it may use technology to
      automatically collect:
    </p>
    <ol type="i">
      <li>
        Usage Details - When you access and use the App, we may automatically
        collect certain details of your access to and use of the App, including
        traffic data, location data, logs and other communication data and the
        resources that you access and use on or through the App.
      </li>
      <li>
        Device Information - We may collect information about your mobile device
        and an internet connection, including the device’s unique identifiers,
        IP address, operating system, browser type, mobile network information
        and the device’s telephone number.
      </li>
      <li>
        Stored Information and Files - The App may also access metadata and
        other information associated with other files stored on your device.
        This may include, for example, device logs or device usage metadata
        information.
      </li>
      <li style="margin-bottom: 14px">
        Location Information - The App collects coarse real-time information
        about the location of your device and its IP address while the App is in
        use. The App will collect and store a user’s location info through
        several different analytics tools. Invitte will not share a user’s
        location information with third parties, and will instead use the
        location information we collect to provide more relevant data to the
        user and to generally enhance our understanding of our user base.
      </li>
    </ol>
    <strong style="margin-bottom: 14px"
      >Information Collection Technologies</strong
    ><br /><br />

    <p style="margin-bottom: 14px">
      The technologies we use for automatic information collection may include:
    </p>

    <ol type="i">
      <li>
        Cookies (or mobile cookies). A cookie is a small file placed on your
        mobile device. It may be possible to refuse to accept mobile cookies by
        activating the appropriate setting on your mobile device. However, if
        you select this setting you may be unable to access certain parts of the
        App.
      </li>
      <li style="margin-bottom: 14px">
        Web Beacons. Pages of the App and our emails may contain small
        electronic files known as web beacons (also referred to as clear gifs,
        pixel tags, and single-pixel gifs) that may permit Invitte, for example,
        to count users who have visited those pages or opened an email and for
        other related App statistics, as well as recording the popularity of
        certain App content and verifying system and server integrity.
      </li>
    </ol>
    <strong style="margin-bottom: 14px"
      >Third-Party Information Collection</strong
    ><br /><br />

    <p style="margin-bottom: 14px">
      When you use the App or its content, certain third parties may use
      automatic information collection technologies to collect information about
      you or your device. These third parties may include:
    </p>
    <ol type="i">
      <li>App store and platform providers.</li>
      <li style="margin-bottom: 14px">Analytics companies</li>
    </ol>
    <p style="margin-bottom: 14px">
      These third parties may use tracking technologies to collect information
      about you when you use the App, including tools like Mixpanel, Google
      Analytics, SegmentIO, Bugsnag, Instabug, FIrebase, LiveChat, Facebook SDK
      and OneSignal. The information they collect may include analytics
      information, device information and location information, as well as your
      email address.
    </p>
    <p style="margin-bottom: 14px">
      We do not control these third parties’ tracking technologies or how they
      may be used. If you have any questions, you should contact the responsible
      provider directly.
    </p>
    <strong>How We Use Your Information</strong><br /><br />
    <p>
      We use information that we collect about you or that you provide to us,
      including any personal information, to:
    </p>
    <ol type="i">
      <li>
        Provide you with the App and its contents and any other information that
        you request from us.
      </li>
      <li>Facilitate your activities with respect to the App</li>
      <li>
        Contact you regarding administrative issues, such as questions about a
        specific request or otherwise respond to your comments or requests.
      </li>
      <li>
        Verify and authenticate your identity, to help us ensure that the
        individuals who use the App are who they claim to be.
      </li>
      <li>
        Prevent, detect, mitigate and investigate fraud, security breaches, and
        potentially prohibited or illegal activities.
      </li>
      <li>Help us operate the App.</li>
      <li>Deliver notices regarding your account.</li>
      <li>
        Send you information we believe is relevant to you, such as news,
        bulletins, marketing materials or other information.
      </li>
      <li>Enforce this Policy and the Terms and Conditions.</li>
      <li>Conduct user surveys and questionnaires.</li>
      <li>Comply with applicable law.</li>
    </ol>
    <p style="margin-bottom: 14px">
      We use aggregated information to analyze the effectiveness of the App, to
      improve the App, and for other similar purposes. In addition, from time to
      time, we may undertake or commission statistical and other summary
      analyses of the general behavior and characteristics of users
      participating in the App, and may share aggregated information with third
      parties. We may collect aggregated information through the features of the
      software that supports the App, through cookies, and through other means
      described in this Policy.
    </p>
    <p style="margin-bottom: 14px">
      To enable us to better understand the characteristics of our users and/or
      to provide services tailored to your needs, we may combine your personal
      information with certain automatically-collected information that would
      not otherwise be personally identifiable. If we combine or link any
      automatically-collected, non-individually identifiable information with
      your personal information, the resulting combination will be treated as
      personal information under this Policy.
    </p>
    <strong style="margin-bottom: 14px">Disclosure of Your Information</strong
    ><br /><br />

    <p style="margin-bottom: 14px">
      We may disclose personal information that we collect or that you provide
      to our affiliates, which may use the personal information in a manner
      consistent with this Policy. We may disclose aggregated information about
      our users or information that does not identify any individuals or device,
      without restriction:
    </p>
    <ol type="i">
      <li>
        To our subsidiaries and affiliates, which may use the aggregated
        information we share in a manner consistent with this Policy.
      </li>
      <li>
        To contractors, service providers and other third parties we use to
        support our business and who are bound by contractual obligations to
        keep such aggregated information confidential and use it only for the
        purposes for which we disclose it to them.
      </li>
      <li>
        In the event of a transaction or proposed transaction involving the
        transfer of substantially all of the assets of Invitte or one or more of
        its businesses to another entity, whether an affiliate or a third party,
        or in connection with a bankruptcy, we may share aggregated information
        in the diligence process or to otherwise facilitate the transaction, and
        with individuals assisting in the transaction or in connection with a
        bankruptcy. Any aggregated information may also be one of the
        transferred assets as part of the transaction or bankruptcy.
      </li>
      <li>
        To the extent we reasonably believe we are required to do so by law or
        to comply with any legal or regulatory requirement or request, or to
        protect against fraud, illegal activity, to otherwise protect Invitte
        from liability.
      </li>
      <li style="margin-bottom: 14px">
        If we believe it is necessary or appropriate to protect the rights,
        property or safety of the App’s users, any third party or Invitte.
      </li>
    </ol>

    <strong style="margin-bottom: 14px">
      Your Choices About Our Collection, Use and Disclosure of Your Information </strong
    ><br /><br />

    <p>
      We strive to provide you with the choices regarding the personal
      information you provide to us. This section describes mechanisms we
      provide for you to control certain uses and disclosures of your
      information.
    </p>
    <ol type="i">
      <li>
        Tracking Technologies. You can set your mobile device to refuse all or
        some mobile cookies, or to alert you when cookies are being sent by
        logging into the App and visiting your account profile page. If you
        disable or refuse cookies or block the use of other tracking
        technologies, some parts of the App may then be inaccessible or not
        function properly.
      </li>
      <li style="margin-bottom: 14px">
        Location Information. You can choose whether or not to allow the App to
        collect and use real-time information about your device’s location by
        logging into the App and visiting your account profile page. If you
        block the use of location information, some parts of the App may then be
        inaccessible or not function properly.
      </li>
    </ol>

    <p style="margin-bottom: 14px">
      In general, you may browse the App without providing personal information.
      However, if you choose not to provide certain personal information through
      the App, we may not be able to provide certain services or process certain
      of your requests. You will not be able to use all of the features that we
      offer through the App. Depending on the functionality associated with the
      App feature you are using, you may be able to update or delete certain of
      your personal information on the App. Accordingly, at your request, we
      will take reasonable steps to remove your personal information from our
      databases. However, please note that:
    </p>
    <ol type="i">
      <li>
        We may not be permitted to delete your personal information completely,
        due to the regulatory reporting requirements and data backups and
        records of deletions.
      </li>
      <li>
        If you request deletion of your personal information, you may be unable
        to use certain features of the App.
      </li>
      <li>
        Certain of your personal information may remain in our databases
        following the deletion of your account.
      </li>
      <li>
        You may not remove de-identified, anonymous, or aggregate data from our
        databases.
      </li>
      <li style="margin-bottom: 14px">
        Any deletion requests may be sent to (insert contact email)
      </li>
    </ol>
    <p style="margin-bottom: 14px">
      If you no longer wish to receive marketing emails from us, you can opt out
      of these communications by logging into the App and visiting your account
      profile page or by contacting us at (insert contact email). Please
      understand that you will not be allowed to opt-out of transactional
      notices or other legal and related notices concerning your relationship to
      the App or your account.
    </p>
    <strong style="margin-bottom: 14px">
      Accessing and Correcting Your Personal Information </strong
    ><br /><br />
    <p style="margin-bottom: 14px">
      You can review and change your personal information by logging into the
      App and visiting your account profile page. You may also send us an email
      at (insert contact email) to request access to, correct or delete any
      personal information that you have provided to us. We cannot delete your
      personal information except by also deleting your user account. We may not
      accommodate a request to change information if we believe the change would
      violate any law or legal requirement or cause the information to be
      incorrect.
    </p>
    <strong style="margin-bottom: 14px">Links to Other Sites</strong
    ><br /><br />
    <p style="margin-bottom: 14px">
      This Policy applies only to information collected on the App or in emails,
      texts and other electronic communications sent through or in connection
      with the App. The App may contain links to other sites that are not owned
      or controlled by Invitte. Invitte is not responsible for the privacy
      practices of such other sites, and we encourage you to be aware when you
      leave the App and to read the privacy statements of each and every site
      that collects your information.
    </p>
    <strong style="margin-bottom: 14px">Data Security</strong><br /><br />

    <p style="margin-bottom: 14px">
      We have put in place reasonable security systems designed to prevent
      unauthorized access to or disclosure of personal information, and we take
      reasonable steps to secure and safeguard this information against loss,
      theft, and unauthorized use, disclosure, or modification. With that said,
      there is no such thing as 100% security of the networks, servers and
      databases we operate or that are operated on our behalf. Before submitting
      any personal information via the App, please be aware of these inherent
      risks and understand that you do so at your own risk. You also play a role
      in protecting your personal information. Please do not share your user
      name or password with others. If we receive an order or instructions using
      your information we will consider that you have authorized the
      transaction.
    </p>
    <strong style="margin-bottom: 14px">Data Retention</strong><br /><br />
    <p style="margin-bottom: 14px">
      We keep your personal information for as long as reasonably necessary for
      the purposes described in this Policy, while we have a legitimate business
      need to do so in connection with your account, or as required by law (e.g.
      for tax, legal, accounting or other purposes), whichever is longer.
    </p>
    <strong style="margin-bottom: 14px">Changes to This Policy</strong
    ><br /><br />
    <p style="margin-bottom: 14px">
      We may update or modify this Policy at any time, which will become
      effective as of our posting on the App. In addition to posting on the App,
      we will notify you that this Policy has been changed through an in-App
      alert the first time you use the App after we make the change.
    </p>
    <p style="margin-bottom: 14px">
      The date this Policy was last revised is identified at the top of the
      page. You are responsible for ensuring we have up-to-date contact
      information for you and for periodically visiting this Policy to check for
      any changes.
    </p>
    <strong style="margin-bottom: 14px">Contact Information</strong><br /><br />
    <p>
      If you have any questions about this Policy, the practices of the App or
      your dealings with the App, please contact us at:
      <a href="#">info@invitte.app</a>
    </p>
    <br /><br /><br /><br />
  </div>
</div>
